import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { DocumentZipFilters } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface Props {
  caseId: string;
  caseName: string;
}

interface DownloadZipResponse {
  downloadUrl: string;
  filterHash?: string;
}

export const useDownloadDocumentZip = ({ caseId, caseName }: Props) => {
  const { getFetchConfig } = useGetFetchConfig();

  const downloadDocumentZip = async (filters?: DocumentZipFilters): Promise<void> => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: filters || {},
    });

    const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/docs/download-zip`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to get zip download URL');
    }

    const data: DownloadZipResponse = await response.json();

    // Create a temporary link to trigger download with appropriate filename
    const fileName = data.filterHash ? `${caseName} (filtered).zip` : `${caseName}.zip`;
    const link = Object.assign(document.createElement('a'), {
      href: data.downloadUrl,
      download: fileName,
    });

    link.click();
  };

  const { mutate: downloadZip, isLoading: isDownloadingZip, error } = useMutation(downloadDocumentZip);

  return { downloadZip, isDownloadingZip, error };
};
